<dx-popup
    #cashReceiptsViewer
    minWidth="150px"
    minHeight="150px"
    width="55%"
    height="80%"
    [title]="title"
    [showCloseButton]="true"
    [shading]="false"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [visible]="visible"
    (onHidden)="onHidden()"
>
    <div *dxTemplate="let data of 'content'">
        <dx-box width="100%" height="100%" direction="col" class="cash-receipt-box">
            <dxi-item baseSize="auto">
                <dx-form class="cash-receipt-form-group" [colCount]="2" labelLocation="left">
                    <dxi-item [isRequired]="true">
                        <dxo-label text="Receipt Date"></dxo-label>
                        <div *dxTemplate>
                            <div class="label-value-text">
                                {{ cashReceiptResult?.receiveDate | date: dateFormat }}
                            </div>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Payer"></dxo-label>
                        <div *dxTemplate>
                            <div class="label-value-text">
                                {{ cashReceiptResult?.payer }}
                            </div>
                        </div>
                    </dxi-item>
                    <dxi-item [isRequired]="true">
                        <dxo-label text="Post Date"></dxo-label>
                        <div *dxTemplate>
                            <div class="label-value-text">
                                {{ cashReceiptResult?.postDate | date: dateFormat }}
                            </div>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Payment Method"></dxo-label>
                        <div *dxTemplate>
                            <div class="label-value-text">
                                {{ cashReceiptResult?.paymentMethod }}
                            </div>
                        </div>
                    </dxi-item>
                    <dxi-item [isRequired]="true">
                        <dxo-label text="Description"></dxo-label>
                        <div *dxTemplate>
                            <div class="font-bold">
                                {{ cashReceiptResult?.description }}
                            </div>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Transaction Date"></dxo-label>
                        <div *dxTemplate>
                            <div class="label-value-text">
                                {{ cashReceiptResult?.transactionDate | date: dateFormat }}
                            </div>
                        </div>
                    </dxi-item>
                    <dxi-item itemType="empty"></dxi-item>
                    <dxi-item>
                        <dxo-label text="Transaction Number"></dxo-label>
                        <div *dxTemplate>
                            <div class="label-value-text">
                                {{ cashReceiptResult?.transactionNumber }}
                            </div>
                        </div>
                    </dxi-item>
                </dx-form>
            </dxi-item>
            <dxi-item [ratio]="1">
                <dx-data-grid
                    #cashReceiptRawGrid
                    height="95%"
                    keyExpr="cmCashReceiptItemId"
                    [dataSource]="cashReceiptLineItems"
                    [allowColumnReordering]="true"
                    [allowColumnResizing]="true"
                    [columnAutoWidth]="true"
                    [showBorders]="true"
                    [showColumnLines]="true"
                    [showRowLines]="true"
                >
                    <dxo-load-panel [enabled]="false"></dxo-load-panel>
                    <dxi-column caption="Item #" cellTemplate="itemNumber"></dxi-column>
                    <dxi-column dataField="glAccountNumber" caption="GL Account No"></dxi-column>
                    <dxi-column dataField="subCategory" caption="Sub Category"></dxi-column>
                    <dxi-column dataField="description" caption="Description"></dxi-column>
                    <dxi-column dataField="amount" caption="Amount" format="$ #,##0.00"></dxi-column>
                    <div *dxTemplate="let item of 'itemNumber'">
                        {{ item.row.rowIndex + 1 }}
                    </div>
                    <div *dxTemplate="let d of 'dimensionTemplate'">
                        {{ getDimensionOptionTitle(d) }}
                    </div>
                    <div *dxTemplate="let d of 'dimensionEditorTemplate'">
                        {{ getDimensionEditorTitle(d) }}
                    </div>
                </dx-data-grid>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <div *ngIf="cashReceiptResult?.defaultBankName" class="note">
                        <i>
                            Note: A/R Default Bank:
                            <strong>{{ cashReceiptResult.defaultBankName }}</strong>
                        </i>
                    </div>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <dx-toolbar width="100%">
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Close"
                                    hint="Close"
                                    [icon]="iconClose"
                                    (onClick)="onHidden()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item location="after">
                            <div *dxTemplate>
                                <dx-button
                                    type="danger"
                                    text="Delete"
                                    hint="Delete"
                                    [icon]="iconDelete"
                                    [visible]="cashReceiptResult?.allowDelete"
                                    (onClick)="onDeleteClick()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item location="after">
                            <div *dxTemplate>
                                <dx-button
                                    type="success"
                                    text="Reverse"
                                    hint="Reverse"
                                    [icon]="iconReverse"
                                    [visible]="cashReceiptResult?.allowReverse"
                                    (onClick)="onReverseClick()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item location="after">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Edit"
                                    hint="Edit"
                                    [icon]="iconEdit"
                                    [visible]="isLimitedEditAllowed || isEditAllowed"
                                    (onClick)="onEditClick()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                    </dx-toolbar>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#cashReceiptsViewer' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>
